import moment from 'moment';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { type ReduxTypes } from 'types/ReduxTypes';

type weekdays =
  | 'monday'
  | 'tuesday'
  | 'wednesday'
  | 'thursday'
  | 'friday'
  | 'saturday'
  | 'sunday';

const useIsDayDisabled = () => {
  const brandInfo = useSelector(({ Brands }: ReduxTypes) => Brands.brand);

  const isDayDisabled = useCallback(
    (date: string | Date) => {
      const weekday = moment(date)
        .locale('en')
        .format('dddd')
        .toLowerCase() as weekdays;

      const weekdayInfo = brandInfo?.[weekday];
      const disabledDays = Array.isArray(brandInfo?.disabledDays)
        ? brandInfo!.disabledDays
        : [];

      if (!weekdayInfo) {
        // Brand information for this weekday is not available yet
        return false;
      }

      return (
        weekdayInfo.shouldBeDeliveredIn === 0 ||
        weekdayInfo.shouldBeDeliveredInBlock === 0 ||
        disabledDays.some((day: string) =>
          moment(day).isSame(moment(date), 'day')
        )
      );
    },
    [brandInfo]
  );

  return isDayDisabled;
};

export default useIsDayDisabled;
